import { gql } from "@apollo/client";


export const VALIDAR_MODULO_RI = gql`
    query validarModuloRI( $idPlanCuidado: Int!){
        validarModuloRI( idPlanCuidado: $idPlanCuidado)
 }
`;